import SwaggerUI from "swagger-ui-react"
import "swagger-ui-react/swagger-ui.css"



console.log(`${process.env.REACT_APP_VERSION}`)

function App() {
  const queryParams = new URLSearchParams(window.location.search)
  const term = queryParams.get("oas_name")
  const url = `https://static.blue.cl/multimedia/swagger/${term}.yaml`;
  return (
    <div className="App">
      <SwaggerUI url={url} />
    </div>
  );
}

export default App;